{
    "name": "oltb",
    "version": "3.5.0",
    "author": "Qulle",
    "license": "BSD-2-Clause license",
    "description": "OLTB is a portable mobile friendly GIS toolbar developed for OpenLayers 10.6.1",
    "keywords": [
        "gis",
        "map",
        "web-gis",
        "toolbar",
        "openlayers"
    ],
    "repository": {
        "type": "git",
        "url": "git+https://github.com/qulle/oltb.git"
    },
    "homepage": "https://github.com/qulle/oltb#readme",
    "bugs": {
        "url": "https://github.com/qulle/oltb/issues"
    },
    "scripts": {
        "start": "parcel serve ./dev/index.html --open --dist-dir ./serve",
        "eslint:src": "eslint --config ./config/.eslintrc.mjs ./src/oltb/js/**/*.js",
        "eslint:src-fix": "eslint --fix --config ./config/.eslintrc.mjs ./src/oltb/js/**/*.js",
        "eslint:dev": "eslint --config ./config/.eslintrc.mjs ./dev/**/*.js",
        "eslint:dev-fix": "eslint --fix --config ./config/.eslintrc.mjs ./dev/**/*.js",
        "test": "cross-env NODE_OPTIONS=--experimental-vm-modules NODE_NO_WARNINGS=1 jest ./src --config ./config/jest.config.mjs",
        "test:watch": "cross-env NODE_OPTIONS=--experimental-vm-modules NODE_NO_WARNINGS=1 jest ./src --watch --config ./config/jest.config.mjs",
        "test:coverage": "cross-env NODE_OPTIONS=--experimental-vm-modules NODE_NO_WARNINGS=1 jest ./src --coverage --config ./config/jest.config.mjs",
        "test:clear": "jest --clearCache",
        "build": "npm run build:demo && npm run build:lib",
        "build:lib": "rollup --config ./config/rollup.config.mjs",
        "build:demo": "parcel build --public-url . ./dev/index.html --dist-dir ./demo",
        "example:cdn:1": "sh -c 'start firefox -url \"file://C:$(cut -c3- <<< $(readlink -m ./examples/cdn/example-1/index.html))\"'",
        "example:npm:1": "parcel serve ./examples/npm/example-1/index.html --open --dist-dir ./serve",
        "example:npm:2": "parcel serve ./examples/npm/example-2/index.html --open --dist-dir ./serve",
        "example:npm:3": "npm --prefix ./examples/npm/example-3-angular start",
        "example:npm:4": "npm --prefix ./examples/npm/example-4-react run dev",
        "clean": "rm -rf ./serve ./dist ./demo ./.parcel-cache",
        "install-husky": "npx husky install",
        "configure-husky": "npx husky install && npx husky add .husky/pre-commit \"npx lint-staged\""
    },
    "lint-staged": {
        "./src/oltb/js/**/*.js": [
            "eslint --config ./config/.eslintrc.mjs"
        ],
        "./dev/**/*.js": [
            "eslint --config ./config/.eslintrc.mjs"
        ]
    },
    "files": [
        "dist"
    ],
    "type": "module",
    "dependencies": {
        "a-color-picker": "^1.2.1",
        "axios": "^1.8.4",
        "browser-dtector": "^4.1.0",
        "html2canvas": "^1.4.1",
        "jsts": "^2.12.1",
        "lodash": "^4.17.21",
        "many-keys-map": "^2.0.1",
        "moment": "^2.30.1",
        "ol": "^10.6.1",
        "proj4": "^2.15.0",
        "screenfull": "^6.0.2",
        "sortablejs": "^1.15.6",
        "tippy.js": "^6.3.7",
        "uuid": "^11.1.0"
    },
    "devDependencies": {
        "@eslint/js": "^9.2.0",
        "@parcel/transformer-sass": "^2.14.4",
        "@rollup/plugin-commonjs": "^28.0.3",
        "@rollup/plugin-json": "^6.1.0",
        "@rollup/plugin-node-resolve": "^16.0.1",
        "@rollup/plugin-replace": "^6.0.2",
        "@rollup/plugin-terser": "^0.4.4",
        "buffer": "^6.0.3",
        "cross-env": "^7.0.3",
        "eslint": "^9.24.0",
        "husky": "^9.1.7",
        "identity-obj-proxy": "^3.0.0",
        "jest": "^29.7.0",
        "jest-environment-jsdom": "^29.7.0",
        "lint-staged": "^15.5.0",
        "parcel": "^2.14.4",
        "process": "^0.11.10",
        "rollup": "^4.39.0",
        "rollup-plugin-license": "^3.6.0",
        "rollup-plugin-scss": "^4.0.1"
    }
}
